/* eslint react/prop-types: 0 */

import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import { useDispatch, useSelector } from "react-redux";
import { Input, Label } from "reactstrap";
import { Icon, Menu, Select } from "semantic-ui-react";
import { getDataAction } from "../config/redux/action";
import { START_YEAR } from "../constants";

export const SelectPerusahaan = (props) => {
  const dispatch = useDispatch();
  const listPerusahaan = useSelector((state) => state.perusahaanReducer.listPerusahaan);
  const value = useSelector((state) => state.main.perusahaanFilter);
  const [Options, setOptions] = useState([]);

  useEffect(() => {
    let option = [];

    listPerusahaan &&
      listPerusahaan.content.map((row, index) => {
        option.push({ value: row.id, text: row.nama });
      });

    if (props.options) {
      option.unshift(props.options);
    }
    setOptions(option);

    if (!value && props.default) {
      if (props.default) {
        dispatch({
          type: "GET_FILTER_PERUSAHAAN",
          data: listPerusahaan && listPerusahaan.content[0]?.id,
        });
      } else {
        dispatch({
          type: "GET_FILTER_PERUSAHAAN",
          data: "",
        });
      }
    }
  }, [listPerusahaan]);

  const handleChange = (e, { value }) => {
    dispatch({
      type: "GET_FILTER_PERUSAHAAN",
      data: value,
    });
  };

  return (
    <>
      <Select
        className={`input--perusahaan ${props.className}`}
        onChange={handleChange}
        value={value}
        options={Options}
        search
        required={props.required}
        placeholder="Pilih Perusahaan Induk"
      />
    </>
  );
};

export const SelectPerusahaanComponent = (props) => {
  const listPerusahaan = useSelector((state) => state.perusahaanReducer.listPerusahaan);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const opt = [];
    listPerusahaan &&
      listPerusahaan.content.map((row, index) => {
        opt.push({ value: row?.id, text: row?.nama });
      });
    setOptions(opt);
  }, [listPerusahaan]);

  return (
    <>
      <Select
        className={`input--perusahaan ${props.className}`}
        onChange={props.onChange}
        value={props.value}
        options={options}
        search
        required={props.required}
        placeholder="Pilih Perusahaan"
      />
    </>
  );
};

export const FinanceTypeList = (props) => {
  const options = [
    { value: 1, text: "Laba Kotor" },
    { value: 4, text: "Laba Bersih" },
    { value: 5, text: "Pendapatan Usaha" },
    { value: 3, text: "EBIT" },
    { value: 2, text: "EBITDA" },

  ];
  return (
    <Select
      search
      value={props.value}
      options={options}
      onChange={props.onChange}
      required={props.required}
      placeholder="Pilih Jenis Laporan"
      className={`input--years ${props.className}`}
    />
  );
};
export const YearList = (props) => {
  const currentYear = new Date().getFullYear();
  const options = [];
  let y = START_YEAR;
  while (y <= currentYear) {
    options.push({ value: y, text: y });
    y++;
  }
  return (
    <Select
      search
      value={props.value}
      options={options}
      onChange={props.onChange}
      required={props.required}
      placeholder="Pilih Tahun"
      className={`input--years ${props.className}`}
    />
  );
};

export const DocumentTypes = (props) => {
  const options = [
    { value: 1, text: "Laporan Keuangan" },
    { value: 2, text: "Laporan Kinerja" },
    { value: 3, text: "Laporan Lainnya" },
  ];
  return (
    <Select
      search
      value={props.value}
      options={options}
      onChange={props.onChange}
      required={props.required}
      placeholder="Pilih Jenis Dokumen"
      className={`input--years ${props.className}`}
    />
  );
};

export const KuartalComponent = (props) => {
  const options = [1, 2, 3, 4].map((k) => ({
    value: k,
    text: `Kuartal ${k}`,
  }));
  return (
    <Select
      search
      value={props.value}
      options={options}
      onChange={props.onChange}
      required={props.required}
      placeholder="Pilih Periode"
      className={`input--years ${props.className}`}
    />
  );
};

export const InputFieldResponsive = (props) => {
  const { inputType, label, onChange } = props;
  return (
    <div className="row mb-2">
      <div className="col-md-4 d-flex align-items-center">
        <Label>{label}</Label>
      </div>
      <div className={`col-md-${props.width || 8}`}>
        {inputType.type === "currency" ? (
          <NumberFormat
            required={inputType.required}
            className="form-control text-right"
            thousandSeparator={true}
            disabled={inputType.disabled}
            prefix={"Rp."}
            value={inputType.value}
            onValueChange={(values) => {
              onChange({
                target: { value: values.value, name: inputType.name },
              });
            }}
          />
        ) : (
          <Input
            onChange={onChange}
            disabled={inputType.disabled}
            name={inputType.name}
            value={inputType.value}
            placeholder={inputType.placeholder}
            required={inputType.required}
            type={inputType.type || "text"}
          />
        )}
      </div>
    </div>
  );
};

export const InputFieldResponsive2 = (props) => {
  const { inputType, label, onChange } = props;
  return (
    <div className="row mb-2">

      <div className="col-md">
        {inputType.type === "currency" ? (
          <NumberFormat
            required={inputType.required}
            className="form-control text-right"
            thousandSeparator={true}
            disabled={inputType.disabled}
            // prefix={"Rp."}
            value={inputType.value}
            onValueChange={(values) => {
              onChange({
                target: { value: values.value, name: inputType.name },
              });
            }}
          />
        ) : (
          <Input
            onChange={onChange}
            disabled={inputType.disabled}
            name={inputType.name}
            value={inputType.value}
            placeholder={inputType.placeholder}
            required={inputType.required}
            type={inputType.type || "text"}
          />
        )}
      </div>
    </div>
  );
};

export const SelectFieldResponsive = (props) => {
  const { inputType, label } = props;
  const cloneProps = { ...props };
  delete cloneProps.inputType;
  return (
    <div className="row mb-2">
      <div className="col-md-4 d-flex align-items-center">
        <Label>{label}</Label>
      </div>
      <div className="col-md-8">
        <Select {...cloneProps} className="w-100" placeholder={inputType.placeholder} options={inputType.options || []} />
      </div>
    </div>
  );
};

export const SelectFilterYear = (props) => {
  const dispatch = useDispatch();
  const yearValue = useSelector((state) => state.main.yearFilter);

  const [options, setOptions] = useState([]);

  const date = new Date();
  const year = date.getFullYear();

  useEffect(() => {
    if (options.length === 0) {
      let tmp = [];
      for (let i = 2011; i < year; i++) {
        tmp.push({ value: i + 1, text: i + 1 });
      }
      setOptions(tmp);
    }

    if (!yearValue) {
      dispatch({
        type: "GET_FILTER_YEAR",
        data: year,
      });
    }
  }, []);

  const handleChange = (e, { value }) => {
    dispatch({
      type: "GET_FILTER_YEAR",
      data: value,
    });
  };

  return (
    <>
      <Select className={`input--years ${props.className}`} value={yearValue} onChange={handleChange} options={options} />
    </>
  );
};

export const MenuMonth = (props) => {
  const dispatch = useDispatch();
  const [dataMonth, setdataMonth] = useState("");
  const month = [
    "Tahunan",
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];
  const main = useSelector((state) => state.main);
  const dataReport = useSelector((state) => state.reportReducer.dataReport);
  const keterangan = props.keterangan ?? true;

  const handleChange = (data) => {
    dispatch({
      type: "GET_FILTER_MONTH",
      monFilter: data.index,
      labelMonth: data.name,
    });
  };

  useEffect(() => {
    dispatch({
      type: "GET_DATA_MONTH",
      dataMonth: "",
    });

    if (props.pathUrl) {
      if (main.dataUser.role < 4) {
        if (main.yearFilter && main.perusahaanFilter) {
          dispatch(
            getDataAction({
              path: `${props.pathUrl}/check?year=${main.yearFilter}&perusahaan=${main.perusahaanFilter}`,
              type: "GET_DATA_MONTH",
            })
          );
        }
      } else {
        if (main.yearFilter) {
          dispatch(
            getDataAction({
              path: `${props.pathUrl}/check?year=${main.yearFilter}&perusahaan=${main.dataUser.perusahaan.id}`,
              type: "GET_DATA_MONTH",
            })
          );
        }
      }
    }
  }, [main.yearFilter, main.perusahaanFilter, props.pathUrl]);

  useEffect(() => {
    setdataMonth(main.dataMonth);
  }, [main.dataMonth]);

  const filterBulan = (index) => {
    const filter = dataMonth && dataMonth.filter((data) => data.month === index && data.status !== 2);
    const value = filter && filter[0] ? true : false;

    return value;
  };

  const filterStatus = (index, status = true) => {
    let filter;
    if (status) {
      filter = dataMonth && dataMonth.filter((data) => data.month === index && data.status === 2);
    }
    // else {
    //   filter = dataMonth && dataMonth.filter((data) => data.month === index + 1);
    // }
    const value = filter && filter[0] ? true : false;

    return value;
  };
  const color = main.labelMonth !== month ? "white" : "black";
  return (
    <>
      <Menu className="w-100" vertical secondary inverted>
        {month.map((month, index) => {
          return (
            <Menu.Item
              key={index}
              name={month}
              color="blue"
              active={main.labelMonth === month}
              onClick={(e, { name }) => handleChange({ name, index })}
            >
              {keterangan ? (
                <>
                  {filterBulan(index) && <Icon name="pencil alternate" className={color} />}
                  {filterStatus(index) && <Icon name="check" className={color} />}
                </>
              ) : (
                filterStatus(index, false) && <Icon name="check" className={color} />
              )}
              {month}
            </Menu.Item>
          );
        })}
      </Menu>
      <hr />
      {keterangan && (
        <div className="mt-1">
          <small>*Keterangan</small>
          <div className="mt-2">
            <div className="mb-2">
              <small>
                <Icon name="check" className="black" />
                Sudah di-<em>approve</em>
              </small>
            </div>
            <div>
              <small>
                <Icon name="pencil alternate" className="black" /> Sudah diisi
              </small>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
